// store/appContextSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const LS_KEY = 'ntx.operatingUnitId';

type AppContextState = {
  operatingUnitId: string | null;
  operatingUnitName?: string | null;
};

const initialState: AppContextState = {
  operatingUnitId: localStorage.getItem(LS_KEY),
  operatingUnitName: null
};

const operatingUnitslice = createSlice({
  name: 'operatingUnitContext',
  initialState,
  reducers: {
    setOperatingUnit(state, action: PayloadAction<{ id: string; name?: string }>) {
      state.operatingUnitId = action.payload.id;
      state.operatingUnitName = action.payload.name ?? null;
      localStorage.setItem(LS_KEY, action.payload.id);
    },
    clearOperatingUnit(state) {
      state.operatingUnitId = null;
      state.operatingUnitName = null;
      localStorage.removeItem(LS_KEY);
    }
  }
});

export const { setOperatingUnit, clearOperatingUnit } = operatingUnitslice.actions;
export default operatingUnitslice.reducer;
